<template>
  <div :class="$style.container">
    <history-item v-if="history.length" v-for="historyItem in history" :key="historyItem.id" :item="historyItem" />
    <div slot="no-data" v-else>
      История заявки пуста
    </div>
  </div>
</template>

<script>
import HistoryItem from "@/components/common/issues/info-sidebar/HistoryItem";

export default {
  name:       "IssueHistory",
  components: { HistoryItem },
  props:      ['history'],
};
</script>

<style lang="scss" module>
.container {
  border: 1px solid #F0F0F0;
  border-radius: 4px;
  padding: 8px 14px;
  overflow: auto;
  flex-shrink: 0;
  //height: 100%;
}
</style>
